import React from "react";
import { Link } from "react-router-dom";

const Header = ({ to, title }) => {
  return (
    <div className="flex items-center gap-3 mb-1">
      <Link to={to}>
        <button
          className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition"
          style={{ border: "none", cursor: "pointer" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="white"
            className="w-5 h-5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </Link>

      <h5 className="font-semibold text-white text-base flex-1">{title}</h5>
    </div>
  );
};

export default Header;
